import { render } from "./PackagesComponent.vue?vue&type=template&id=5dc0d527&lang=true"
import script from "./PackagesComponent.vue?vue&type=script&lang=js"
export * from "./PackagesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__